import "./Style.css";
import React,{useState, useEffect} from 'react';
import { useNavigate } from "react-router-dom";
import CurrencyRupeeIcon from '@mui/icons-material/CurrencyRupee';
import StarIcon from "@mui/icons-material/Star";

const TalkAstroFile = ({ data }) => {
  const navigate = useNavigate();

  const astrologerChats = ["AcharyaPrem"];
  const [contactNo, setContactNo] = useState('');
  const [astrologersChat, setAstrologersChat] = useState([]);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await fetch('https://app.astrovedaguru.com/api/getAstrologer', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
           
          },
          body: JSON.stringify({})
        });
        
        if (!response.ok) 
        {
          throw new Error('Failed to fetch data');
        }
        const data = await response.json();
        if (Array.isArray(data.recordList)) {
          const slicedData = data.recordList.slice(0, 6);
          setAstrologersChat(slicedData);
        } else {
          console.error('Expected array, received:', data.recordList);
        }
      } catch (error) {
        console.error('Error fetching data:', error);
      }
    };

    fetchData();
  }, []);
  
  const handleCardClick = (astrologer) => {
    if (astrologerChats.length > 0) {
      if (astrologer.contactNo) {
        setContactNo(astrologer.contactNo);
        sendContactNumber(astrologer.contactNo);

      }
      
      const formattedName = astrologer.name.toLowerCase().replace(/\s+/g, '-'); 
      navigate(`/${formattedName}`, { state: { astrologerData: astrologer } });
    }
  };

  const sendContactNumber = async (contactNumber) => {
    try {
      const response = await fetch('https://app.astrovedaguru.com/api/loginAppAstrologer', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ contactNo: contactNumber }),
      });

      if (!response.ok) {
        throw new Error(`HTTP error! Status: ${response.status}`);
      }

      const jsonData = await response.json();
      console.log('API response:', jsonData);
      
    } catch (error) {
      console.error('Error sending contact number:', error);
    }
  };

 

  return (
    <>
      {astrologersChat.map((astrologer, index) => (
        <div className="col-xl-2 col-lg-2 col-md-3 col-sm-6 col-xs-6 col-12 mb-1 card3" onClick={() => handleCardClick(astrologer)} key={index}>
          <img src={`https://app.astrovedaguru.com/${astrologer.profileImage}`} className="card-img-top imgdata" alt="..." />
          <div className="card-body">
           
            <p className="card-title rname">{astrologer.name}</p>
            <p><span><StarIcon sx={{ fontSize: "18px", color: "#d73878" }} /><StarIcon sx={{ fontSize: "18px", color: "#d73878" }} /><StarIcon sx={{ fontSize: "18px", color: "#d73878" }} /><StarIcon sx={{ fontSize: "18px", color: "#d73878" }} /><StarIcon sx={{ fontSize: "18px", color: "#d73878" }} /></span></p>
            <p className="rate"><span style={{ fontWeight: "700" }} ><span style={{ fontWeight: "800" }}>
              <CurrencyRupeeIcon sx={{ fontSize: "18px", marginRight: "-5px", marginBottom: "1px" }} />
            </span> {astrologer.charge}</span>/min</p>
            <div className="card-btn">
              <button type="button" className="btn-1">
                <i className="fa fa-phone" style={{ fontSize: "24px" }}></i></button>
              <span className="span-1">Call Now</span>
            </div>
          </div>
          <div className="extra"></div>
        </div>
      ))}
    </>
  );
};

export default TalkAstroFile;